import React from 'react';
import {Col, Jumbotron} from 'reactstrap';

const VotePlaceholder = ({text}) => {

    return (
      <Col>
          <Jumbotron>
              <h1 className="text-center m-0">{text}</h1>
          </Jumbotron>
      </Col>
    );
}

export default VotePlaceholder;



// WEBPACK FOOTER //
// ./src/containers/Project/VotePlaceholder.js